import Chart from "react-apexcharts";

const options = {
  chart: {
    type: "radialBar"
  },

  colors: ["#CFB9EC"],

  plotOptions: {
    radialBar: {
      hollow: {
        margin: 15,
        size: "60%"
      },
      track: {
        dropShadow: {
          enabled: true,
          top: 2,
          left: 0,
          blur: 4,
          opacity: 0.15
        }
      },
      dataLabels: {
        showOn: "always",
        name: {
          offsetY: -10,
          show: false,
          color: "#888",
          fontSize: "0.813rem"
        },
        value: {
          color: "#111",
          fontSize: "1.875rem",
          show: true
        }
      }
    }
  },

  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      gradientToColors: ["#61359C"],
      stops: [0, 100]
    }
  },

  stroke: {
    lineCap: "round"
  }
  // labels: [""]
};

const series = [
  {
    name: "series-1",
    data: [30, 40]
  }
];

const CircleGauge = ({ score }) => {
  return (
    <div id="circle-graph" style={{paddingLeft: "2.188rem"}}>
      <Chart
        options={options}
        series={[score]}
        type={"radialBar"}
        width={320}
      />
    </div>
  );
};

export default CircleGauge;
